// extracted by mini-css-extract-plugin
export default {"container":"all-product-images-module__container___ivdtd","image":"all-product-images-module__image___inhae","activeImage":"all-product-images-module__activeImage___tw9ue"};